// extracted by mini-css-extract-plugin
export default {"title":"about_title__2KbaO","body":"about_body__PIH3Z","img":"about_img__imzfA","header":"about_header__9svbc","subHeader":"about_subHeader__0Htgl"};